import { TextureView } from '../../../view/TextureView';
import { EnvironmentObject } from '../EnvironmentObject';

/**
 * Abstraction layer for {@link CustomObject CustomObjects}.\
 * These are {@link EnvironmentObject EnvironmentObjects} that are not part of the standard DICOM data model.\
 * They are created by the user and are not stored in the database.
 *
 * {@link CustomObject CustomObjects} are also not rendered on any of the {@link Layer}s.\
 * Instead they are rendered directly on the {@link TextureView} using their custom {@link render}-method at the end of the render cycle.
 */
export abstract class CustomObject extends EnvironmentObject {
    /**
     * Method that is called when the {@link CustomObject} should be rendered.\
     * This method should be used to render the {@link CustomObject} onto the {@link TextureView}.
     */
    public abstract render(view: TextureView): void;

    /**
     * Optional method that should be used to clear the WebGL memory allocated by this {@link CustomObject}.\
     * If the {@link CustomObject} does not consume any WebGL memory, this method may be left out.
     */
    public delete(): void {}
}
